import {
  AiOutlineUser,
  AiOutlineSetting
} from "react-icons/ai";
import { HiOutlineDeviceMobile, HiOutlinePresentationChartLine } from "react-icons/hi";
import { FaDog, FaHandHoldingDollar } from "react-icons/fa6";
import { IoMdNotificationsOutline } from "react-icons/io";
import { VscGraph, VscFeedback } from "react-icons/vsc";
const data = [
  {
    id: "analytics",
    icon: <VscGraph />,
    label: "Analytics",
  },

  {
    id: "users",
    icon: <AiOutlineUser />,
    label: "Users",
  },
  {
    id: "pets",
    icon: <FaDog />,
    label: "Pets",
  },
  {
    id: "benchmark",
    icon: <HiOutlinePresentationChartLine />,
    label: "Benchmark",
  },
  {
    id: "device",
    icon: <HiOutlineDeviceMobile />,
    label: "Device",
  },
  {
    id: "plan",
    icon: <FaHandHoldingDollar />,
    label: "Plan",
  },
  {
    id: "feedback",
    icon: <VscFeedback />,
    label: "Feedback",
  },
  {
    id: "notification",
    icon: <IoMdNotificationsOutline />,
    label: "Notification",
  },
  {
    id: "config",
    icon: <AiOutlineSetting />,
    label: "App Config",
  },

  //   id: "expenses",
  //   icon: <BiWallet />,
  //   label: "Expenses",
  //   subMenu: [
  //     {
  //       id: "detail",
  //       icon: <SlWallet />,
  //       label: "Details",
  //     },
  //     {
  //       id: "Vehical",
  //       icon: <BsTruck />,
  //       label: "Vehical",
  //     },
  //   ],
  // },
  // {
  //   id: "maintenance",
  //   icon: <HiOutlineWrench />,
  //   label: "Maintenance",
  // },
  // {
  //   id: "employee",
  //   icon: <MdPeopleOutline />,
  //   label: "Employee",
  // },
  // {
  //   id: "logBook",
  //   icon: <GoBook />,
  //   label: "Log Book",
  //   subMenu: [
  //     {
  //       id: "log",
  //       icon: <RxActivityLog />,
  //       label: "Log",
  //     },
  //     {
  //       id: "ABTMeter",
  //       icon: <CgFileDocument />,
  //       label: "ABT Meter",
  //     },
  //     {
  //       id: "cleaningLog",
  //       icon: <TbFileStack />,
  //       label: "Cleaning Log",
  //     },
  //   ],
  // },

];
export default data;
